interface BlogData {
    cardTitle: string,
    cardDescription: string,
    image: string,
}

export const blogData: BlogData[] = [
    {
        cardTitle: "Okap",
        cardDescription: "Sitwe nan nò Ayiti, Okap se yon vil istorik kote ou jwenn aksè nan sit tankou Sitadèl Laferyè, Palè Sans-Souci, ak plaj Labadee.",
        image: "/images/au-cap.jpg",
    },
    {
        cardTitle: "Jakmèl",
        cardDescription: "Jakmèl se yon vil kote sou wout bò lanmè ki konnen pou achitekti fransè kolonyal li yo, atmosfè atistik li, ak karnaval anive.",
        image: "/images/jacmel1.jpg",
    },
    {
        cardTitle: "Pòtoprens",
        cardDescription: "Kapital Ayiti a ofri yon eksperyans vivan ak yon plongeon nan kilti kontanporen Ayisyen an. Ou kapab vizite MIZANPAN, eksplore kote istorik Petion-Vil.",
        image: "/images/potoprens.jpg",
    },
    {
        cardTitle: "Ilavach",
        cardDescription: "Ti zile sa a bèl ki sitiye deyò nan kòt sid-ouè Ayiti a se yon vre bijou. Ak plaj yo ki gen sable blan ak yon anviwònman trankil.",
        image: "/images/ilavach.jpg",
    },
];